import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '@coreAuth/useCase';
import { SigninTag } from '@components';
import type { IAuth } from '@coreAuth/type';

const Login = () => {
  const navigate = useNavigate();
  const { mutate, isSuccess, isLoading } = useLogin();

  useEffect(() => {
    if (isSuccess) navigate('/dashboard', { replace: true });
  }, [isSuccess]);

  const handleAuth = (loginData: IAuth) => {
    mutate(loginData);
  };
  return (
    <SigninTag
      loading={isLoading}
      authCallback={handleAuth}
      onNoAccClick={() => navigate('/register', { replace: true })}
      onGoogleAuthSuccess={() => navigate('/story', { replace: true })}
    />
  );
};

export default Login;
